module.exports = __webpack_public_path__ + "media/images/chrome_icon-9de54ec80762cca98253a107b90265ef.png";